__turbopack_context__.v({
  "tooltip-content": "TGSEBG_tooltip-content",
  "trigger": "TGSEBG_trigger",
  "trigger-visible": "TGSEBG_trigger-visible",
});
